export const APP_TIMEZONE = 'Europe/Moscow'

function parseAppDate(value: string | Date): Date {
  if (value instanceof Date) return value
  const backendUtcNaive =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(value)
  return new Date(backendUtcNaive ? `${value}Z` : value)
}

export function formatAppDateTime(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions,
  fallback = '—',
): string {
  if (!value) return fallback
  const date = parseAppDate(value)
  return date.toLocaleString('ru-RU', {
    ...options,
    timeZone: APP_TIMEZONE,
  })
}

export function appDateStamp(date = new Date()): string {
  return date.toLocaleDateString('sv-SE', { timeZone: APP_TIMEZONE })
}
